import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session";

const persistConfig = {
    key: "commonPersisted",
    storage,
};

const initialState = {
    selectedLanguage: "",
    onDemandAmount: null,
    onDemandLoaded: false,
    enableLocalisation: false,
};

const commonPersistedSlice = createSlice({
    name: "commonPersisted",
    initialState,
    reducers: {
        setSelectedLanguage(state, action) {
            state.selectedLanguage = action.payload;
        },
        setOnDemandAmount(state, action) {
            state.onDemandAmount = action.payload;
        },
        setOnDemandLoaded(state, action) {
            state.onDemandLoaded = action.payload;
        },
        enableLocalisation(state, action) {
            state.enableLocalisation = action.payload;
        },
    },
});

export const persistedCommonSliceReducer = persistReducer(
    persistConfig,
    commonPersistedSlice.reducer
);

export const {
    setSelectedLanguage,
    setOnDemandAmount,
    setOnDemandLoaded,
    enableLocalisation,
} = commonPersistedSlice.actions;

export default commonPersistedSlice.reducer;
